<template>
  <v-list>
    <v-list-item style="display: none;">
      <social-sharing url="https://honeylemon.market"
                      title="Sweet Deals in Cryptocurrency Mining"
                      description="HoneyLemon aggregates available mining contracts, for transparency, standardization and price discovery."
                      quote="Discover the best prices across crypto mining contracts of various maturities on HoneyLemon.market"
                      hashtags="honeylemon"
                      twitter-user="HoneylemonM"
                      inline-template>
        <div>
          <network network="facebook"><div id="share-facebook">facebook</div></network>
          <network network="twitter"><div id="share-twitter">twitter</div></network>
          <network network="reddit"><div id="share-reddit">reddit</div></network>
        </div>
      </social-sharing>
    </v-list-item>
    <v-list-item @click="document.getElementById('share-facebook').click()">
      <v-icon>mdi-facebook</v-icon> Facebook
    </v-list-item>
    <v-list-item @click="document.getElementById('share-twitter').click()">
      <v-icon>mdi-twitter</v-icon> Twitter
    </v-list-item>
    <v-list-item @click="document.getElementById('share-reddit').click()">
      <v-icon>mdi-reddit</v-icon> Reddit
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "ShareMenu",
  data() {
    return {
      document
    };
  }
}
</script>

<style scoped lang="scss">

</style>